<template>
  <div class="leo2-app-home">
    <div class="logo">
      <!--<img src="../assets/imagesMobile/logo.png"/>-->
    </div>
    <!-- 
    <span class="news" @click="goPage()">
          资讯动态
        </span> -->

    <div class="app-home-btn" @click="startMake(true)">
      <img src="../assets/imagesMobile/button.png?v=1" />
    </div>

    <div class="mask" v-if="browser.wechat || browser.qq" @click="closeMask()">
      <img v-if="browser.android" src="../assets/images/guide_android.png" />
      <img v-if="browser.ios" src="../assets/images/guide_ios.png" />
    </div>
    <div class="mask-layer" v-if="browser.wechat || browser.qq" @click="closeMask()"></div>
  </div>
</template>

<script>
import { utils } from "../utils";
import { BaseUrl } from "../utils/config.js";
export default {
  name: 'index',
  data() {
    return {
      install: {},
      IsLogin: 0, // 是否登录 0未登录 1登录
      IsthirdLocate: {
        IsAppstore: 0, // 是否APP store版本
        QQUrl: '',
        WXUrl: ''
      }, // 安卓判断是否跳到应用商店
      isAndroid: false,
      isIos: false,
      downloadUrl: {},
      isDisabled: false,
      browser: {}
    }
  },
  mounted() {
    this.browser = utils.Browser;
    if (this.browser.wechat || this.browser.qq) {
      document.title = ""
    } else {
      document.title = "OK赚 - 一个创造价值的试玩APP";
    }
    // this.startMake(false)
    this.isLogin()
    this.thirdLocate();
    this.init();
  },
  methods: {
    init() {
      this.axios.install().then((res) => {
        this.install = res.data.data;
        if (parent.frames.length > 0 && this.install.download_type == 1 && this.install.payload_type == 2) {
          //通知上级设置添加主屏幕json
          window.top.postMessage({ cmd: 'install', data: res.data.data }, '*');
        } else if (parent.frames.length > 0 && this.install.download_type == 0 && this.install.payload_type == 2) {
          //下载方式已改变,通知上级重新加载界面
          window.top.postMessage({ cmd: 'reload', url: window.location.href }, '*');
        }
      })
    },
    goPage() {
      this.$router.push({
        path: '/news'
      })
    },
    startMake(bool) {
      const ua = navigator.userAgent.toLowerCase();
      if (utils.Browser.android) { // 安卓
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信
          if (bool) {
            // 判断是否要跳转到应用商店
            if (this.IsthirdLocate.QQUrl || this.IsthirdLocate.WXUrl) {
              window.location.href = this.IsthirdLocate.QQUrl ? this.IsthirdLocate.QQUrl : this.IsthirdLocate.WXUrl
            } else {
              this.isAndroid = true;
            }
          }
        } else if (ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) { // QQ
          this.axios.install().then((res) => {
            this.downloadUrl = res.data.data
            window.location.href = this.downloadUrl.DownloadUrl
          })
        } else { // (多此一举，但是还是这样写吧)安卓其它浏览器也是直接下载
          this.axios.install().then((res) => {
            this.downloadUrl = res.data.data
            window.location.href = this.downloadUrl.DownloadUrl
          })
        }
      } else if (utils.Browser.ios || utils.Browser.ipad || utils.Browser.iphone) {
        // 声明：写的我自己都懵逼了~~~~
        if (bool) {
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信
            if (this.IsthirdLocate.IsAppstore === 0 && this.IsthirdLocate.WXUrl === '') {
              this.isIos = true;
            } else if (this.IsthirdLocate.IsAppstore === 1 && this.IsthirdLocate.WXUrl === '') {
              this.$router.push({
                path: '/install'
              })
            } else {
              this.$router.push({
                path: '/install'
              })
            }
          } else if (ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) { // QQ
            if (this.IsthirdLocate.IsAppstore === 0 && this.IsthirdLocate.QQUrl === '') {
              this.isIos = true;
            } else if (this.IsthirdLocate.IsAppstore === 1 && this.IsthirdLocate.QQUrl === '') {
              this.$router.push({
                path: '/install'
              })
            } else {
              this.$router.push({
                path: '/install'
              })
            }
          } else {
            // 如果没有登录，就跳转到下载页面，如果登录，直接跳转到ios首页
            if (this.IsLogin === 0) {
              if (this.install.payload_type == 2 && this.install.download_type == 1) {
                //添加主屏幕
                window.location.href = BaseUrl + 'ios/wapenter?url=' + window.location.href + '&t=' + new Date().getTime();
              } else {
                //其他安装
                this.$router.push({
                  path: '/install'
                })
              }
            } else { // 登录的情况下直接跳转到首页
              window.location.href = BaseUrl + 'ios/home'
            }
          }
        }
      }
    },
    closeMask() { // 关闭提示
      this.isAndroid = false
      this.isIos = false
    },

    isLogin() {
      this.axios.isLogin().then(res => {
        this.IsLogin = res.data.data.IsLogin
      })
    },
    thirdLocate() {
      this.axios.thirdLocate().then(res => {
        this.IsthirdLocate = res.data.data
      })
    }
  }
}
</script>

<style scoped lang="scss">
.leo2-app-home {
    max-width: 750px;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #f44336 url("../assets/imagesMobile/pic.png?v=1") no-repeat center;
    background-size: 100% auto;

    .logo {
        width: 78px;
        height: 45px;
        background: url("../assets/imagesMobile/logo_mobile.png") no-repeat center;
        background-size: 100% auto;
        margin-top: 20px;
        margin-left: 20px;
        clear: both;
        float: left;
        /*img {*/
        /*width: 100%;*/
        /*float: left;*/
        /*}*/
    }

    .news {
        float: right;
        width: 90px;
        height: 27px;
        line-height: 27px;
        text-align: center;
        background-color: #ffa16b;
        margin-top: 35px;
        color: #f44336;
        font-size: 13px;
        border-top-left-radius: 27px;
        border-bottom-left-radius: 27px;
        cursor: pointer;
    }

    .app-home-btn {
        position: absolute;
        bottom: 30px;
        left: 50%;
        margin-left: -105px;
        width: 211px;
        height: 61px;
        text-align: center;

        img {
            vertical-align: middle;
            width: 211px;
            height: 61px;
        }
    }

    .mask {
        width: 375px;
        position: absolute;
        right: 4px;
        top: 10px;
        z-index: 10000;

        img {
            width: 375px;
        }
    }

    .mask-layer {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f44336;
        // opacity: 0.7;
        z-index: 1000;
    }
}
</style>
